@if (profile) {
  <div class="flex flex-col flex-[1_1_100%]">
    <div class="flex flex-row flex-[1_1_100%] justify-center items-center">
      <div class="flex justify-center items-center profile-column">
        @if (profile.image) {
          <img class="mat-elevation-z2 profile-img" [src]="profile.image" loading="lazy">
        }
        @if (!profile.image) {
          <img class="mat-elevation-z2 profile-img default" [src]="defaultSrc" loading="lazy">
        }
      </div>
      <button mat-button (menuOpened)="openedMenu()" [matMenuTriggerFor]="menu" aria-label="Menu for staff Profile">
        <span class="mat-subtitle-2">{{profile.first_name + ' ' + profile.last_name}}</span>
        <mat-icon>{{menuIcon}}</mat-icon>
      </button>
      <mat-menu #menu="matMenu" (closed)="closedMenu()">
        <button mat-menu-item (click)="openSwitcher($event, switcherBtn)" #switcherBtn>
          <mat-icon>swap_calls</mat-icon>
          <span>{{'switch account' | translate}}</span>
        </button>
        <button mat-menu-item (click)="lockCounter()">
          <mat-icon>screen_lock_landscape</mat-icon>
          <span>{{'lock Counter' | translate}}</span>
        </button>
        <button mat-menu-item (click)="logout.emit()">
          <mat-icon>power_settings_new</mat-icon>
          <span>{{'FORM.ACTIONS.LOGOUT' | translate}}</span>
        </button>
      </mat-menu>
    </div>
  </div>
}
